import { SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, Unique, UpdateDateColumn, VersionColumn } from "typeorm";
import { GrnItemReturns } from "../grn-returns/grn-item-return-entity";
import { GrnReturns } from "../grn-returns/grn-return-entity";
import { GrnItems } from "./grn-items.entity";

@Entity("grn")
@Unique('grnNumbers',['grnNumber'])
export class Grn {
    @PrimaryGeneratedColumn("increment", { name: 'grn_id' })
    grnId: number;

    @Column({
        nullable: false,
        name: "grn_date"
    })
    grnDate: Date;

    @Column({
        nullable: false,
        name: "invoice_date"
    })
    InvoiceDate: Date;

    @Column("varchar", {
        nullable: false,
        name: "grn_no"
    })
    grnNumber: string;

    @Column("varchar", {
        nullable: false,
        name: "inv_no"
    })
    invoiceNumber: string;

    @Column("int", {
        nullable: false,
        name: "po_id"
    })
    poId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId: number;

    @Column("decimal", {
        nullable: false,
        name: "total_quantity"
    })
    totalQuantity: number;

    @Column("decimal", {
        nullable: false,
        name: "total_discount"
    })
    totalDiscount: number;

    @Column("decimal", {
        nullable: false,
        name: "total_tax"
    })
    totalTax: number;

    @Column("decimal", {
        nullable: false,
        name: "total_cost"
    })
    totalCost: number;

    @Column("int", {
        nullable: false,
        name: "vendor_id"
    })
    vendorId: number;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "remarks"
    })
    remarks: string;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "approvar"
    })
    approvar: string;

    @Column("int", {
        nullable: false,
        name: "reference_number"
    })
    referenceNumber: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        default: SoStatusEnum.OPEN,
        name: "status"
      })
    status: string;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => GrnItems, grnItems => grnItems.grnInfo, { cascade: true })
    grnItemsInfo: GrnItems[];

    @OneToMany(type => GrnReturns, grnRtn => grnRtn.grnId, { cascade: true })
    grnReturnInfo: GrnReturns[];
}

